import React from 'react'
import PropTypes from 'prop-types'

import {
    Box,
    Text,
    Button,
    IconButton,
    Image
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage, FormattedNumber} from 'react-intl'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {
    closeButton,
    continueButton,
    overlay,
    overlayDesc,
    overlayDescText
} from './paypalOverlay.style'
import {CloseIcon} from '@chakra-ui/icons'
import {pxToRem} from '../../../../utills/pxToRem'

const PaypalOverlay = ({continuePayPalCheckout, handleOverlayClose}) => {
    return (
        <Box sx={overlay} onClick={continuePayPalCheckout}>
            <IconButton
                icon={
                    <CloseIcon height={pxToRem(16)} width={pxToRem(16)} color="cav_overlay_gray" />
                }
                variant="unstyled"
                onClick={handleOverlayClose}
                sx={closeButton}
            />
            <Box sx={overlayDesc}>
                <Image src={getAssetUrl('static/img/checkout/pay-pal.svg')} alt="paypal" h="35px" />
                <Text sx={overlayDescText}>
                    <FormattedMessage
                        defaultMessage="Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  "
                        id="checkout_payment.paypal.overlay_desc"
                    />
                </Text>
                <Button sx={continueButton} variant={'link'} onClick={continuePayPalCheckout}>
                    Click to Continue
                </Button>
            </Box>
        </Box>
    )
}
PaypalOverlay.propTypes = {
    continuePayPalCheckout: PropTypes.func,
    handleOverlayClose: PropTypes.func
}

export default PaypalOverlay
